import React from "react";
import { Dropdown, Option } from "@fluentui/react-components";
import { VOICE_LIST } from "./GenericData/voiceList";
import { useTranslation } from "react-i18next";
import "./CSS/Language.css";
export default function Language(props) {
  const { t } = useTranslation();
  return (
  <Dropdown
className="language-dropdown"
    placeholder={t("SELECT_LANGUAGE")}
    value={props.language}
    selectedOptions={props.language ? [props.language] : []}
    onOptionSelect={(_, data) => props.setLangue(data.optionValue)}
    required
        disabled={props.disabled}
  >
    {VOICE_LIST.map((item) => (
      <Option key={item.header} value={item.header}>
        {item.header}
      </Option>
    ))}
  </Dropdown>

  );
}
